<template>
  <div class="mian-core">
    <basiCcontainer>
      <template #head>
        <div class="head-tool">
          <el-tabs v-model="saveQuery.activeName" class="tabs-flow">
            <!-- <el-tab-pane label="通讯录" name="0"></el-tab-pane> -->
            <el-tab-pane label="团队分析" name="0"></el-tab-pane>
            <el-tab-pane label="项目执行情况" name="1"></el-tab-pane>
          </el-tabs>
        </div>
      </template>
      <div class="flex-box-main">
        <div class="treeLeft" v-loading="loading">
          <el-select ref="selct" class="tree-search" :class="{'show-clear':query && searchQuery}" v-model="selectDepart" no-data-text="没有找到此部门" clearable filterable remote reserve-keyword placeholder="搜索部门" :remote-method="remoteMethod" :loading="searchLoading" @change="selectChage" @visible-change="selctValueChange">
            <div slot="prefix" class="depart-icon">
              <i class="icon iconfont iconicon_search1"></i>
            </div>
            <el-option v-for="item in options" :key="item.depart_id" :label="item.breadcrumbs_name" :value="item.depart_id">
            </el-option>
          </el-select>
          <el-aside width="100%">
            <el-tree :default-expanded-keys="expandEle" ref="tree" :data="treeData" highlight-current :expand-on-click-node="false" :props="{label:'name'}" @node-click="handleNodeClick" node-key="depart_id" :current-node-key="saveQuery.currentNodeKey">
              <span class="custom-tree-node" slot-scope="{ node }">
                <toolTip style="width:100%;" :title="node.label"><span>{{ node.label }}</span></toolTip>
              </span>
            </el-tree>
          </el-aside>
        </div>
        <component class="flex-box-main-right" ref="plateform" :is="list[saveQuery.activeName]" :params="paramsSet" :checkNode="checkNode"></component>
      </div>
    </basiCcontainer>
  </div>
</template>
<script>
// import plateform from '../plateform'
import teamInfo from '../teamInfo'
import progressOverview from '../progressOverview'
import api from '@/services/api/team/team'
import { mapActions, mapState, mapMutations } from 'vuex'
import bus from '@/bus'
export default {
  components: {
    // plateform,
    teamInfo,
    progressOverview
  },
  data() {
    return {
      // list: ['plateform', 'teamInfo', 'progressOverview'],
      list: ['teamInfo', 'progressOverview'], // 隐藏通讯录
      currentRole: 'plateform',
      loading: false,
      treeArrId: [],
      dataset: [],
      paramsSet: [],
      isRoleSee: false,
      searchInput: '',
      timer: null,
      resolve: null,
      node: null,
      checkNode: null,
      selectDepart: '',
      searchLoading: false,
      options: [],
      treeData: [],
      expandEle: [0],
      searchQuery: '',
      query: '',
      saveQuery: {
        activeName: 0,
        currentNodeKey: 0
      }
    }
  },
  watch: {
    saveQuery: {
      handler() {
        this.changeUrl(this.saveQuery)
      },
      deep: true,
    }
  },
  created() {
  },
  mounted() {
    this.init()
    bus.$on('selectDepart', item => {
      this.$refs.tree.setCurrentKey(item.depart_id)
      this.expandEle = item.department_tree.split(',').filter(res => res)
      let nodes = this.$refs.tree.store.nodesMap
      for (let i in nodes) {
        if (nodes[i].data.depart_id === item.depart_id) {
          this.checkNode = nodes[i]
          this.saveQuery.currentNodeKey = item.depart_id
          return
        }
      }
      console.log(item,this.checkNode)
    })
    this.$refs.selct.$el.getElementsByClassName('el-icon-')[0].addEventListener('click', this.selctInputClick)
  },
  destroyed() {
    bus.$off('selectDepart')
  },
  computed: {
    ...mapState('layout/layout', {
      userInfo: state => state.userInfo
    })
  },
  methods: {
    async init() {
      this.loading = true
      let result = await api.myManagementAndDepartmentIndex({ pid: 0, level: 100 })
      let tree = (dataset) => {
        dataset.map(item => {
          if (item.children && item.children.data) {
            item.children = item.children.data
          } else {
            return
          }
          if (item.children && item.children.length > 0) {
            tree(item.children)
          }
        })
      }
      tree(result.data)
      this.treeData = [{
        name: '亿航智能设备有限公司',
        depart_id: 0,
        isLeaf: false,
        department_tree: '0',
        children: result.data
      }]
      this.loading = false
      this.$nextTick(() => {
        let activeName = this.$route.query.activeName
        let currentNodeKey = this.$route.query.currentNodeKey
        console.log(activeName, currentNodeKey)

        this.saveQuery.activeName = activeName || '0'
        this.saveQuery.currentNodeKey = currentNodeKey ? Number(currentNodeKey) : 0
        this.$refs.tree.setCurrentKey(this.saveQuery.currentNodeKey)
        this.checkNode = this.$refs.tree.getNode(this.saveQuery.currentNodeKey)


        let selected = this.$refs.tree.getCurrentNode()
        if (this.$refs.tree.getNode(selected) && this.$refs.tree.getNode(selected).parent) {
          this.expandParents(this.$refs.tree.getNode(selected).parent)
        }
      })
    },
    expandParents(node) {
      node.expanded = true;
      if (node.parent) {
        this.expandParents(node.parent);
      }
    },
    childNodeset(result) {
      if (!result) return []
      result.map(res => {
        res.isLeaf = res.children_amount ? false : true
        return res
      })
      return result
    },
    handleNodeClick(data, node, indeterminate) {
      console.log(node)
      this.checkNode = node
      this.saveQuery.currentNodeKey = node.data.depart_id
    },
    getTreeItem(treeDataset, depart_id) {
      for (let i = 0; i < treeDataset.length; i++) {
        if (treeDataset[i].depart_id === depart_id) {
          return treeDataset[i]
        } else if (treeDataset[i].children && treeDataset[i].children.length > 0) {
          let item = this.getTreeItem(treeDataset[i].children, depart_id)
          if (item) {
            return item
          }
        }
      }
    },
    async remoteMethod(query) {
      this.query = query
      this.searchLoading = true
      let result = await api.addressBookSearch({ keyword: query, page: 1, number: 999 })
      this.options = result.data
      this.searchLoading = false
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    selectChage() {
      if (!this.selectDepart) {
        this.options = []
        return
      }
      let item = this.options.find(res => res.depart_id === this.selectDepart)
      this.$refs.tree.setCurrentKey(item.depart_id)
      this.expandEle = item.department_tree.split(',').filter(res => res)
      let nodes = this.$refs.tree.store.nodesMap
      for (let i in nodes) {
        if (nodes[i].data.depart_id === this.selectDepart) {
          this.checkNode = nodes[i]
          this.saveQuery.currentNodeKey = item.depart_id
          return
        }
      }
    },
    selctValueChange(val) {
      this.searchQuery = val
      if (!val) {
        this.query = ''
      }
    },
    selctInputClick() {
      this.query && this.searchQuery ? this.$refs.selct.visible = false : ''
    },
    changeUrl(obj) {
      var url = window.location.href
      var params = new URLSearchParams(window.location.search);
      for(let key in obj) {
        params.set(key, obj[key]);
      }
      var newUrl = url.split('?')[0]+ '?'+ params.toString();
      window.history.pushState({},'',newUrl);
    }
  }
}
</script>
<style lang="scss" src="./style.scss">
</style>
<style lang="scss">
  .mian-core {
    .treeLeft {
      .tree-search{
        padding: 24px 16px;
        padding-bottom: 10px;
      }
    }
  }
</style>
